// Do not edit this file, it is auto-generated at build time!
import { lazy } from 'react';

const AIAssistantPage = lazy(() => import('../components/pages/AIAssistantPage'));
const AboutFacultyPage = lazy(() => import('../components/pages/AboutFacultyPage'));
const CartPage = lazy(() => import('../components/pages/CartPage'));
const CertificatesPage = lazy(() => import('../components/pages/CertificatesPage'));
const CheckoutPage = lazy(() => import('../components/pages/CheckoutPage'));
const CollectionProduct = lazy(() => import('../components/pages/CollectionProduct'));
const CreditClassPage = lazy(() => import('../components/pages/CreditClassPage'));
const CreditFormatPage = lazy(() => import('../components/pages/CreditFormatPage'));
const CreditInfoRiverPage = lazy(() => import('../components/pages/CreditInfoRiverPage'));
const CreditInfoTypePage = lazy(() => import('../components/pages/CreditInfoTypePage'));
const CreditPlanGeneratedPage = lazy(() => import('../components/pages/CreditPlanGeneratedPage'));
const CreditPlanParentPage = lazy(() => import('../components/pages/CreditPlanParentPage'));
const CreditTrackerAdminPage = lazy(() => import('../components/pages/CreditTrackerAdminPage'));
const CreditTrackerPage = lazy(() => import('../components/pages/CreditTrackerPage'));
const DebugPage = lazy(() => import('../components/pages/DebugPage'));
const ErrorPage = lazy(() => import('../components/pages/ErrorPage'));
const FacultyMember = lazy(() => import('../components/pages/FacultyMember'));
import * as GenericPage from '../components/pages/GenericPage';
const GlobalErrorPage = lazy(() => import('../components/pages/GlobalErrorPage'));
const IndustryNode = lazy(() => import('../components/pages/IndustryNode'));
const IntendedAudienceNode = lazy(() => import('../components/pages/IntendedAudienceNode'));
const JurisdictionCreditInfoPage = lazy(
  () => import('../components/pages/JurisdictionCreditInfoPage')
);
const LibraryPage = lazy(() => import('../components/pages/LibraryPage'));
const LicensesPage = lazy(() => import('../components/pages/LicensesPage'));
const MobileStoreRedirectPage = lazy(() => import('../components/pages/MobileStoreRedirectPage'));
const OperationalSearchResultPage = lazy(
  () => import('../components/pages/OperationalSearchResultPage')
);
const OrderConfirmationPage = lazy(() => import('../components/pages/OrderConfirmationPage'));
const PodcastPage = lazy(() => import('../components/pages/PodcastPage'));
const PracticeAreaPage = lazy(() => import('../components/pages/PracticeAreaPage'));
const PressReleaseDetailPage = lazy(() => import('../components/pages/PressReleaseDetailPage'));
const ProfileSettingsPage = lazy(() => import('../components/pages/ProfileSettingsPage'));
const RuleChangesPage = lazy(() => import('../components/pages/RuleChangesPage'));
const SearchPage = lazy(() => import('../components/pages/SearchPage'));
const StandardHeadlessPage = lazy(() => import('../components/pages/StandardHeadlessPage'));
const StartPage = lazy(() => import('../components/pages/StartPage'));
const SubjectNode = lazy(() => import('../components/pages/SubjectNode'));
const PodcastSeriesNode = lazy(() => import('../components/pages/catalog/PodcastSeriesNode'));
const AnswerBookSingleTitleSubscriptionVariation = lazy(
  () => import('../components/pages/catalog/variations/AnswerBookSingleTitleSubscriptionVariation')
);
const AnswerBookVariation = lazy(
  () => import('../components/pages/catalog/variations/AnswerBookVariation')
);
const CourseHandbookSingleTitleSubscriptionVariation = lazy(
  () =>
    import('../components/pages/catalog/variations/CourseHandbookSingleTitleSubscriptionVariation')
);
const CourseHandbookVariation = lazy(
  () => import('../components/pages/catalog/variations/CourseHandbookVariation')
);
const IndividualMembershipVariation = lazy(
  () => import('../components/pages/catalog/variations/IndividualMembershipVariation')
);
const IndividualPlusSubscriptionVariation = lazy(
  () => import('../components/pages/catalog/variations/IndividualPlusSubscriptionVariation')
);
const LiveProgramGroupcastVariation = lazy(
  () => import('../components/pages/catalog/variations/LiveProgramGroupcastVariation')
);
const LiveProgramInteractiveWebcastVariation = lazy(
  () => import('../components/pages/catalog/variations/LiveProgramInteractiveWebcastVariation')
);
const LiveProgramOhbVariation = lazy(
  () => import('../components/pages/catalog/variations/LiveProgramOhbVariation')
);
const LiveProgramPBRWebcastVariation = lazy(
  () => import('../components/pages/catalog/variations/LiveProgramPBRWebcastVariation')
);
const LiveProgramPbrSeminarVariation = lazy(
  () => import('../components/pages/catalog/variations/LiveProgramPbrSeminarVariation')
);
const LiveProgramSeminarVariation = lazy(
  () => import('../components/pages/catalog/variations/LiveProgramSeminarVariation')
);
const LiveProgramWebcastVariation = lazy(
  () => import('../components/pages/catalog/variations/LiveProgramWebcastVariation')
);
const OnDemandInteractiveVariation = lazy(
  () => import('../components/pages/catalog/variations/OnDemandInteractiveVariation')
);
const OnDemandMp3Variation = lazy(
  () => import('../components/pages/catalog/variations/OnDemandMp3Variation')
);
const OnDemandMp4Variation = lazy(
  () => import('../components/pages/catalog/variations/OnDemandMp4Variation')
);
const OnDemandOhbMp3Variation = lazy(
  () => import('../components/pages/catalog/variations/OnDemandOhbMp3Variation')
);
const OnDemandOhbMp4Variation = lazy(
  () => import('../components/pages/catalog/variations/OnDemandOhbMp4Variation')
);
const OnDemandOhbWebVariation = lazy(
  () => import('../components/pages/catalog/variations/OnDemandOhbWebVariation')
);
const OnDemandPbrWebVariation = lazy(
  () => import('../components/pages/catalog/variations/OnDemandPbrWebVariation')
);
const OnDemandWebVariation = lazy(
  () => import('../components/pages/catalog/variations/OnDemandWebVariation')
);
const PodcastEpisodeVariation = lazy(
  () => import('../components/pages/catalog/variations/PodcastEpisodeVariation')
);
const TreatiseSingleTitleSubscriptionVariation = lazy(
  () => import('../components/pages/catalog/variations/TreatiseSingleTitleSubscriptionVariation')
);
const TreatiseVariation = lazy(
  () => import('../components/pages/catalog/variations/TreatiseVariation')
);

const pages = new Map();

pages.set('AIAssistantPage', AIAssistantPage);
pages.set('AboutFacultyPage', AboutFacultyPage);
pages.set('CartPage', CartPage);
pages.set('CertificatesPage', CertificatesPage);
pages.set('CheckoutPage', CheckoutPage);
pages.set('CollectionProduct', CollectionProduct);
pages.set('CreditClassPage', CreditClassPage);
pages.set('CreditFormatPage', CreditFormatPage);
pages.set('CreditInfoRiverPage', CreditInfoRiverPage);
pages.set('CreditInfoTypePage', CreditInfoTypePage);
pages.set('CreditPlanGeneratedPage', CreditPlanGeneratedPage);
pages.set('CreditPlanParentPage', CreditPlanParentPage);
pages.set('CreditTrackerAdminPage', CreditTrackerAdminPage);
pages.set('CreditTrackerPage', CreditTrackerPage);
pages.set('DebugPage', DebugPage);
pages.set('ErrorPage', ErrorPage);
pages.set('FacultyMember', FacultyMember);
pages.set('GenericPage', GenericPage);
pages.set('GlobalErrorPage', GlobalErrorPage);
pages.set('IndustryNode', IndustryNode);
pages.set('IntendedAudienceNode', IntendedAudienceNode);
pages.set('JurisdictionCreditInfoPage', JurisdictionCreditInfoPage);
pages.set('LibraryPage', LibraryPage);
pages.set('LicensesPage', LicensesPage);
pages.set('MobileStoreRedirectPage', MobileStoreRedirectPage);
pages.set('OperationalSearchResultPage', OperationalSearchResultPage);
pages.set('OrderConfirmationPage', OrderConfirmationPage);
pages.set('PodcastPage', PodcastPage);
pages.set('PracticeAreaPage', PracticeAreaPage);
pages.set('PressReleaseDetailPage', PressReleaseDetailPage);
pages.set('ProfileSettingsPage', ProfileSettingsPage);
pages.set('RuleChangesPage', RuleChangesPage);
pages.set('SearchPage', SearchPage);
pages.set('StandardHeadlessPage', StandardHeadlessPage);
pages.set('StartPage', StartPage);
pages.set('SubjectNode', SubjectNode);
pages.set('PodcastSeriesNode', PodcastSeriesNode);
pages.set('AnswerBookSingleTitleSubscriptionVariation', AnswerBookSingleTitleSubscriptionVariation);
pages.set('AnswerBookVariation', AnswerBookVariation);
pages.set(
  'CourseHandbookSingleTitleSubscriptionVariation',
  CourseHandbookSingleTitleSubscriptionVariation
);
pages.set('CourseHandbookVariation', CourseHandbookVariation);
pages.set('IndividualMembershipVariation', IndividualMembershipVariation);
pages.set('IndividualPlusSubscriptionVariation', IndividualPlusSubscriptionVariation);
pages.set('LiveProgramGroupcastVariation', LiveProgramGroupcastVariation);
pages.set('LiveProgramInteractiveWebcastVariation', LiveProgramInteractiveWebcastVariation);
pages.set('LiveProgramOhbVariation', LiveProgramOhbVariation);
pages.set('LiveProgramPBRWebcastVariation', LiveProgramPBRWebcastVariation);
pages.set('LiveProgramPbrSeminarVariation', LiveProgramPbrSeminarVariation);
pages.set('LiveProgramSeminarVariation', LiveProgramSeminarVariation);
pages.set('LiveProgramWebcastVariation', LiveProgramWebcastVariation);
pages.set('OnDemandInteractiveVariation', OnDemandInteractiveVariation);
pages.set('OnDemandMp3Variation', OnDemandMp3Variation);
pages.set('OnDemandMp4Variation', OnDemandMp4Variation);
pages.set('OnDemandOhbMp3Variation', OnDemandOhbMp3Variation);
pages.set('OnDemandOhbMp4Variation', OnDemandOhbMp4Variation);
pages.set('OnDemandOhbWebVariation', OnDemandOhbWebVariation);
pages.set('OnDemandPbrWebVariation', OnDemandPbrWebVariation);
pages.set('OnDemandWebVariation', OnDemandWebVariation);
pages.set('PodcastEpisodeVariation', PodcastEpisodeVariation);
pages.set('TreatiseSingleTitleSubscriptionVariation', TreatiseSingleTitleSubscriptionVariation);
pages.set('TreatiseVariation', TreatiseVariation);

export function pageFactory(pageName: string) {
  const page = pages.get(pageName);

  return page?.Default || page?.default || page;
}
